import { Typography } from '@mui/material';
import { INTER, NAVY } from '../../studentStyles';

// Authored questions can mix English and pinyin. Inter covers tone-marked Latin
// letters without the visibly different per-glyph fallback in Poppins.
export default function ExercisePrompt({ text, centered = false }: { text: string; centered?: boolean }) {
    return <Typography sx={{ fontFamily: INTER, fontWeight: 600, fontSize: 20, color: NAVY, lineHeight: 1.35, textAlign: centered ? 'center' : 'left' }}>{text}</Typography>;
}
